import { render, staticRenderFns } from "./quizSystem.vue?vue&type=template&id=2040bacc&scoped=true&"
import script from "./quizSystem.vue?vue&type=script&lang=js&"
export * from "./quizSystem.vue?vue&type=script&lang=js&"
import style0 from "./quizSystem.vue?vue&type=style&index=0&id=2040bacc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2040bacc",
  null
  
)

export default component.exports